import { FC } from 'react';

import { FormHelperRenderer } from '@hh.ru/magritte-ui-form-helper/FormHelperRenderer';
import { FormHelperProps } from '@hh.ru/magritte-ui-form-helper/types';
import { useFormHelperState } from '@hh.ru/magritte-ui-form-helper/useFormHelperState';

export const FormHelper: FC<FormHelperProps> = (props) => {
    const formHelperState = useFormHelperState(props);
    return <FormHelperRenderer {...props} {...formHelperState} />;
};
